import { render, staticRenderFns } from "./RealEstateItemEdit.vue?vue&type=template&id=59796258&scoped=true&"
import script from "./RealEstateItemEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateItemEdit.vue?vue&type=style&index=0&id=59796258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59796258",
  null
  
)

export default component.exports